/* eslint-disable @typescript-eslint/no-explicit-any */

/* eslint-disable max-len */
import { Button, Checkbox, Col, Form, Row } from 'antd';
import React, { useContext, useState } from 'react';
import { ILeiData } from 'types/leiTypes';

import Paragraph from 'components/atoms/Paragraph';
import Title from 'components/atoms/Title';
import { Context } from 'components/hoc/Store';
import TranslateText from 'components/hoc/TranslateText';

import useNavigateWorkaround from 'hooks/useNavigateWorkaround';

import { ETypMatky } from 'enums/lei/leiDataEnums';
import { EMaterskaSpol } from 'enums/lei/materskaSpol';
import routePathEnum from 'enums/routePathEnum';

import DetailInfoPrehled from '../formularPages/PrehledPages/DetailInfoPrehled';
import FinalniMatkaPrehled from '../formularPages/PrehledPages/FinalniMatkaPrehled';
import PrimaMatkaPrehled from '../formularPages/PrehledPages/PrimaMatkaPrehled';
import ProfondyPrehled from '../formularPages/PrehledPages/ProfondyPrehled';
import UpravaLeiDetail from '../formularPages/upravaLeiDetail';
import Osoba from './Osoba';

interface IPrehled {
    formData?: ILeiData;
    prevStep: () => void;
    nextStep: () => void;
    PrehledOnly?: boolean;
}

const Prehled: React.FC<IPrehled> = ({ prevStep, nextStep, formData, PrehledOnly }) => {
    const [form] = Form.useForm();
    const { navigateWorkaround } = useNavigateWorkaround();
    const { cisStaty, aktivniFirma } = useContext(Context);
    const [consentChecked, setConsentChecked] = useState<{ chck1: boolean; chck2: boolean; chck3: boolean }>({
        chck1: false,
        chck2: false,
        chck3: false
    });

    const primaMatkaData = formData?.matky?.filter(
        e => e.typmatky === ETypMatky.IS_DIRECTLY_CONSOLIDATED_BY || e.typmatky === ETypMatky.IS_INTERNATIONAL_BRANCH_OF
    );
    const internationalMatkaData = formData?.matky?.filter(e => e.typmatky === ETypMatky.IS_INTERNATIONAL_BRANCH_OF);
    const finalniMatkaArr = formData?.matky?.filter(e => e.typmatky === ETypMatky.IS_ULTIMATELY_CONSOLIDATED_BY);
    const finalniMatkaData = finalniMatkaArr && finalniMatkaArr.length > 0 ? finalniMatkaArr : undefined;

    const { FIRMA_PLAIN, LEI_DETAIL } = routePathEnum;
    const baseURL = `${FIRMA_PLAIN}${aktivniFirma?.iducet}`;

    const submitFunc = () => {
        nextStep();
    };

    return formData ? (
        <>
            <Osoba formDataOsoba={formData?.osoba} isPrehled={true} />
            <Title
                level={5}
                dividerTitle={true}
                text={'LEI_DETAIL_INFO_TITLE'}
                style={{
                    marginTop: 10
                }}
            />
            <DetailInfoPrehled formDataSpolecnost={formData?.spolecnost} typZadosti={formData?.typzadosti} />

            <UpravaLeiDetail
                nextStep={() => {}}
                prevStep={() => {}}
                setCurrentStep={() => {}}
                formData={formData}
                setFormData={() => {}}
                setIsEdit={() => {}}
                isPrehled={true}
                PrehledOnly={PrehledOnly}
                cisStaty={cisStaty}
            />

            <Title
                level={5}
                dividerTitle={true}
                text={formData?.typzadosti === 'BRANCH' ? 'LEI_DETAIL_MAT_TITLE_BRANCH' : 'LEI_DETAIL_MAT_TITLE'}
                style={{
                    marginTop: 10
                }}
            />
            <PrimaMatkaPrehled
                cisStaty={cisStaty}
                primaMatkaData={primaMatkaData}
                upravaForm={form}
                internationalMatkaData={internationalMatkaData}
            />
            {formData?.typzadosti !== 'BRANCH' && (
                <>
                    <Title
                        level={5}
                        dividerTitle={true}
                        text="LEI_FINAL_TITLE"
                        style={{
                            marginTop: 10
                        }}
                    />

                    <FinalniMatkaPrehled
                        cisStaty={cisStaty}
                        finalniMatkaData={finalniMatkaData}
                        upravaForm={form}
                        primaMatkaStav={
                            (primaMatkaData && primaMatkaData.length && primaMatkaData[0].stav) || undefined
                        }
                        disabled={primaMatkaData && primaMatkaData[0].stav === EMaterskaSpol.NE}
                    />
                </>
            )}
            {formData?.typzadosti === 'FUND' && (
                <>
                    <Title level={5} dividerTitle={true} text="LEI_FOND_TITLE" />
                    <ProfondyPrehled vsechnyMatky={formData.matky} />
                </>
            )}

            {!PrehledOnly && (
                <>
                    <Row>
                        <Col span={1}>
                            <Checkbox
                                onChange={() =>
                                    setConsentChecked(pv => {
                                        return {
                                            ...pv,
                                            chck1: !pv.chck1
                                        };
                                    })
                                }
                                checked={consentChecked.chck1}
                                id="consent-chk1"
                            />
                        </Col>
                        <Col span={23}>
                            <Paragraph text="LEI_PREVOD_SUBMIT_APPROVAL1" />
                        </Col>
                    </Row>
                    <Row>
                        <Col span={1}>
                            <Checkbox
                                onChange={() =>
                                    setConsentChecked(pv => {
                                        return {
                                            ...pv,
                                            chck2: !pv.chck2
                                        };
                                    })
                                }
                                checked={consentChecked.chck2}
                                id="consent-chk2"
                            />
                        </Col>
                        <Col span={23}>
                            <Paragraph text="LEI_PREVOD_SUBMIT_APPROVAL2" />
                        </Col>
                    </Row>
                    <Row>
                        <Col span={1}>
                            <Checkbox
                                onChange={() =>
                                    setConsentChecked(pv => {
                                        return {
                                            ...pv,
                                            chck3: !pv.chck3
                                        };
                                    })
                                }
                                checked={consentChecked.chck3}
                                id="consent-chk3"
                            />
                        </Col>
                        <Col span={23}>
                            <Paragraph text="LEI_PREVOD_SUBMIT_APPROVAL3" />
                        </Col>
                    </Row>
                </>
            )}
            <>
                <div
                    style={{
                        marginTop: 20
                    }}
                >
                    <Button
                        onClick={() => (PrehledOnly ? navigateWorkaround(`${baseURL}${LEI_DETAIL}`) : prevStep())}
                        id="prehledZpetBtn"
                    >
                        <TranslateText>ZPET</TranslateText>
                    </Button>
                    {!PrehledOnly && (
                        <Button
                            id="prehledOdeslatBtn"
                            style={{
                                margin: '0 8px'
                            }}
                            type="primary"
                            disabled={!consentChecked.chck1 || !consentChecked.chck2 || !consentChecked.chck3}
                            onClick={() => {
                                submitFunc();
                            }}
                        >
                            <TranslateText>POKRACOVAT</TranslateText>
                        </Button>
                    )}
                </div>
            </>
        </>
    ) : (
        <></>
    );
};

export default Prehled;
